import { Routes } from '@angular/router';

import { LoginComponent } from '../../pages/login/login.component';
import { PasswordResetComponent } from '../../pages/password-reset/password-reset.component';
import { SignUpComponent } from '../../pages/sign-up/sign-up.component';

export const LoginLayoutRoutes: Routes = [
    { path: 'login',                   component: LoginComponent },
    { path: 'finishsignup',            component: SignUpComponent },
    { path: 'password_reset',          component: PasswordResetComponent }
];
